import { TaskType } from './task-type';
import { User } from './user';
import { Subject } from './subject';
import { IEntity } from '../interfaces/entity';
import { Guid } from '../helpers/guid';

export interface ITaskList {
  items: Task[];
  totalCount: number;
}

export class Task implements IEntity {
  id: number;
  uid: string;

  summary: string;
  notes: string;
  dateCreated: Date;
  dateDue?: Date;
  dateCompleted?: Date;
  taskStatus: number;
  taskStatusName: string;
  state: string;

  actionFor: User;
  actionForId: number;
  actionedBy: User;
  actionedById: number;
  createdById: number;
  createdBy: User;

  taskTypeId: number;
  taskType: TaskType;
  labels: string;
  important: boolean;
  starred: boolean;
  subjectId: number;
  subject: Subject;
  readOnly: boolean;
  organisationId: number;

  constructor(task?) {
    {
      this.id = 0;
      this.uid = '';
      this.updateTask(task);
    }
  }

  public updateTask(task: Task) {
    if (task === undefined) {
      return;
    }
    this.id = task.id;
    this.uid = task.uid || Guid.newGuid();
    this.notes = task.notes;
    this.summary = task.summary;
    this.dateCreated = task.dateCreated;
    this.dateDue = task.dateDue;
    this.dateCompleted = task.dateCompleted;
    this.taskStatus = task.taskStatus;
    this.taskStatusName = task.taskStatusName;
    this.actionFor = task.actionFor;
    this.actionForId = task.actionForId;
    this.actionedBy = task.actionedBy;
    this.actionedById = task.actionedById;
    this.taskTypeId = task.taskTypeId;
    this.taskType = task.taskType;
    this.labels = task.labels;
    this.createdById = task.createdById;
    this.createdBy = task.createdBy;
    this.important = task.important;
    this.starred = task.starred;
    this.subjectId = task.subjectId;
    this.subject = task.subject;
    this.state = task.state;
    this.readOnly = task.readOnly;
    this.organisationId = task.organisationId;
  }

  toggleStar() {
    this.starred = !this.starred;
  }

  toggleImportant() {
    this.important = !this.important;
  }

  setTaskCompleted() {
    // ActionedById is set server side. These values are for client side for now.
    this.taskStatusName = 'Completed';
    this.actionedBy = null;
    this.taskStatus = 30;
    this.dateCompleted = new Date(Date.now());
  }

  setTaskAbandoned() {
    this.taskStatusName = 'Abandoned';
    this.taskStatus = 40;
    this.dateCompleted = null;
    this.actionedBy = null;
    this.actionedById = null;
  }
}
